// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1WEiS","contentWraps":"dbHhO","borders":"_2e6Sg","subheadings":"_2_kt8","heading-texts":"VPbpu","hideBody":"_1aRO5","showBody":"_2YONv"};